// src/app/televisit-layer.ts
//
// The app shell's overlay layer over the workspace frame, where the encounter's video panel lives
// (Flutter positions its FloatingVideoWidget in the encounter screen's Stack: right of the nav
// rail, below the top bar, not scrolled with the page). The layer is `absolute` over the frame's
// box and ignores the pointer; the panel inside it takes the pointer back.

/** DOM id of the overlay layer `AppShell` renders over `main.shell-frame`. */
export const TELEVISIT_LAYER_ID = 'pa-televisit-layer';
